/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_DutchInputs */

const en_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dutch`)
};

const fr_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neerlandais`)
};

const de_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niederländisch`)
};

const it_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olandese`)
};

const ru_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голландский`)
};

const es_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holandés`)
};

const zh_cn2_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`荷兰语`)
};

const ja_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オランダ語`)
};

const hi_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डच`)
};

const pt_pt2_speechmatics_target_language_dutch = /** @type {(inputs: Speechmatics_Target_Language_DutchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holandês`)
};

/**
* | output |
* | --- |
* | "Dutch" |
*
* @param {Speechmatics_Target_Language_DutchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_dutch = /** @type {((inputs?: Speechmatics_Target_Language_DutchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_DutchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_dutch(inputs)
	if (locale === "de") return de_speechmatics_target_language_dutch(inputs)
	if (locale === "it") return it_speechmatics_target_language_dutch(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_dutch(inputs)
	if (locale === "es") return es_speechmatics_target_language_dutch(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_dutch(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_dutch(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_dutch(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_dutch(inputs)
	return en_speechmatics_target_language_dutch(inputs)
});